<template>
    <nav class="manual-breadcrumbs" :aria-label="lang('manual::manual.path')">
        <template v-for="(item, index) in items" :key="item.uid">
            <span v-if="index > 0" class="manual-breadcrumbs__separator" aria-hidden="true">→</span>
            <button type="button" class="manual-breadcrumbs__item" @click="$emit('select', item.uid)">
                {{ item.title }}
            </button>
        </template>
    </nav>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';

defineProps<{ items: Array<{ uid: string; title: string }> }>();
defineEmits<{ select: [uid: string] }>();
</script>

<style scoped>
.manual-breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.75rem;
    margin-bottom: 0.75rem;
}
.manual-breadcrumbs__separator {
    opacity: 0.4;
}
.manual-breadcrumbs__item {
    opacity: 0.6;
    text-align: left;
}
.manual-breadcrumbs__item:hover {
    opacity: 1;
    text-decoration: underline;
}
</style>
